import AppBar from '@material-ui/core/AppBar'
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import IconButton from '@material-ui/core/IconButton'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import MenuIcon from '@material-ui/icons/Menu'
import { Col, Row } from 'antd'
import PropTypes from 'prop-types'
import React from 'react'
import { withRouter } from 'react-router-dom'
import styled from 'styled-components'
import { isMobile } from '../../utils'
import LogoutDialog from './components/LogoutDialog'
import { styles } from './styles'
import _ from 'lodash'
import MenuAccountProfile from './components/MenuAccountProfile'
import MenuAccountLocation from './components/MenuAccountLocation'
import MenuAccountProduct from './components/MenuAccountProduct'
import MenuAccountFactory from './components/MenuAccountFactory'
import MenuAccountDocument from './components/MenuAccountDocument'
import MenuAccountBinProfile from './components/MenuAccountBinProfile'
import MenuAccountBinLocation from './components/MenuAccountBinLocation'
import MenuAccountBin from './components/MenuAccountBin'
import MenuFactoryAnnouncement from './components/MenuFactoryAnnouncement'
import { Image } from '../../shared.style'
import { useSelector } from 'react-redux'

const CardContentEx = styled(CardContent)``

export const Account = ({ me, heroConfig, history, ToggleDrawer, Logout }) => {
  const [open, setOpen] = React.useState(false)
  const { heroNewsItem } = useSelector((state) => state.heroNewsItems)

  const openInNewTab = (url) => {
    const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
    if (newWindow) newWindow.opener = null
  }

  return (
    <React.Fragment>
      <AppBar position="sticky">
        <Toolbar>
          <IconButton
            id="btnMenu"
            style={styles.menuButton}
            color="inherit"
            aria-label="Menu"
            onClick={() => ToggleDrawer()}>
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" color="inherit" style={styles.grow}>
            Home
          </Typography>
        </Toolbar>
      </AppBar>
      <Card elevation={isMobile ? 0 : 1} square>
        <CardContentEx>
          <Row style={{ marginBottom: '1rem' }}>
            {!_.isEmpty(heroNewsItem) && (
              <Image
                src={heroNewsItem[0].newsItemImage}
                alt="heroNews"
                height={500}
                onClick={() => openInNewTab(`${heroNewsItem[0].url}`)}
              />
            )}
          </Row>
          <Row gutter={[24, 24]} style={{ marginTop: '10%' }}>
            {me.heroType !== 'CIRCULAR_BIN' ? (
              me.heroType === 'FACTORY' || me.heroType === 'RECYCLE_SHOP' ? (
                <Col span={12}>
                  {me.status === 'APPROVED' ? (
                    <MenuFactoryAnnouncement history={history} />
                  ) : (
                    <MenuAccountProfile history={history} />
                  )}
                </Col>
              ) : (
                <Col span={12}>
                  <MenuAccountProfile history={history} />
                </Col>
              )
            ) : (
              <Col span={12}>
                <MenuAccountBinProfile history={history} />
              </Col>
            )}
            {me.heroType !== 'CIRCULAR_BIN' && me.heroType !== 'POSTAL' && (
              <Col span={12}>
                <MenuAccountLocation history={history} />
              </Col>
            )}
            {me.heroType !== 'CIRCULAR_BIN' && me.heroType !== 'FACTORY' && (
              <Col span={12}>
                <MenuAccountProduct history={history} />
              </Col>
            )}
            {me.heroType === 'FACTORY' && (
              <Col span={12}>
                <MenuAccountFactory history={history} />
              </Col>
            )}
            {me.heroType !== 'CIRCULAR_BIN' && me.heroType !== 'POSTAL' && (
              <Col span={12}>
                <MenuAccountDocument history={history} />
              </Col>
            )}
            {me.heroType === 'CIRCULAR_BIN' && (
              <Col span={12}>
                <MenuAccountBinLocation history={history} />
              </Col>
            )}
            {me.heroType === 'CIRCULAR_BIN' && (
              <Col span={24}>
                <Row type="flex" justify="center">
                  <MenuAccountBin history={history} />
                </Row>
              </Col>
            )}
          </Row>
        </CardContentEx>
      </Card>
      <LogoutDialog open={open} onOk={Logout} onClose={() => setOpen(false)} />
    </React.Fragment>
  )
}

Account.propTypes = {
  me: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  ToggleDrawer: PropTypes.func.isRequired,
  Logout: PropTypes.func.isRequired
}

export default withRouter(Account)



// WEBPACK FOOTER //
// ./src/pages/Account/index.js